import React, { useCallback, useState } from "react";
import { connectStripe, getConnectStatus } from "../../../services/api";

/**
 * Opens Stripe onboarding in a new tab and refreshes the connect status when
 * that tab is closed.
 */
export const useConnectOnboarding = (
  setConnectStatus: React.Dispatch<React.SetStateAction<string | null>>,
) => {
  const [onboardProcessing, setOnboardProcessing] = useState(false);

  const initiateConnectOnboarding = useCallback(
    async (e?: React.MouseEvent) => {
      if (e) e.stopPropagation();
      const newWin = window.open("", "_blank");
      setOnboardProcessing(true);
      let pollInterval: number | null = null;
      const clearPoll = () => {
        if (pollInterval !== null) {
          window.clearInterval(pollInterval);
          pollInterval = null;
        }
      };
      const closeWindow = () => {
        if (!newWin) return;
        try {
          newWin.close();
        } catch (_) {}
      };

      try {
        const url = await connectStripe();
        if (!url) {
          closeWindow();
          setOnboardProcessing(false);
          return;
        }
        if (newWin) {
          newWin.opener = null;
          newWin.location.href = url;
          pollInterval = window.setInterval(async () => {
            try {
              if (newWin.closed) {
                clearPoll();
                try {
                  const status = await getConnectStatus();
                  setConnectStatus(status);
                } catch {
                } finally {
                  setOnboardProcessing(false);
                }
              }
            } catch {}
          }, 1000);
        }
      } catch {
        closeWindow();
        clearPoll();
        setOnboardProcessing(false);
      }
    },
    [setConnectStatus],
  );

  return { onboardProcessing, initiateConnectOnboarding };
};
